import { PaytrieAPI } from '@paytrie/client'

import axios from './axios'

const signupEndpoints = {
  VERIFICATION_LINK: 'verificationLink',
}

const getErrorMessage = (res: { data: unknown }): string => {
  if (
    res.data &&
    typeof res.data === 'object' &&
    'errors' in res.data &&
    Array.isArray((res.data as { errors?: Array<{ message?: string }> }).errors)
  ) {
    return (
      (res.data as { errors?: Array<{ message?: string }> }).errors?.[0]
        ?.message ?? ''
    )
  }
  return ''
}

export type SendSMSResult =
  | { kind: 'success' }
  | { kind: 'error'; message: string }

export async function sendSMS(phoneNumber: string): Promise<SendSMSResult> {
  try {
    const res = await PaytrieAPI.sendPhoneVerification({
      phone: phoneNumber,
    })
    if (res.status === 202) {
      return { kind: 'success' }
    }
    return { kind: 'error', message: getErrorMessage(res) }
  } catch {
    return { kind: 'error', message: 'Unable to send SMS verification code.' }
  }
}

export type VerifySMSResult =
  | { kind: 'success' }
  | { kind: 'phone_already_claimed' }
  | { kind: 'error'; message: string }

export async function verifySMS(phoneCode: string): Promise<VerifySMSResult> {
  try {
    const res = await PaytrieAPI.verifyPhone({ code: phoneCode })
    if (res.status === 409) {
      return { kind: 'phone_already_claimed' }
    }
    if (res.status !== 204) {
      return { kind: 'error', message: getErrorMessage(res) }
    }
    return { kind: 'success' }
  } catch {
    return { kind: 'error', message: 'Unable to verify phone number.' }
  }
}

// Validates that the input string is a valid date formatted as "yyyy-mm-dd"
export function isValidDate(dateString: string): boolean {
  // Parse the date parts to integers
  const parts = dateString.split('-')
  const day = parseInt(parts[2], 10)
  const month = parseInt(parts[1], 10)
  const year = parseInt(parts[0], 10)

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return false
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29
  }

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1]
}

// of form V6J1K8
export function testCanadianPostalCode(postalCode: string): boolean {
  const postalCodeRegex =
    //  /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVXY]\d$/i;
    /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i
  return postalCodeRegex.test(postalCode)
}

export function testIsValidName(input: string): boolean {
  const isAlphaRegex = /^[a-zA-Z]+(?:[\s.'-][a-zA-Z]+)*$/
  return isAlphaRegex.test(input)
}

export type ImageData = {
  name: string
  type: string
  url: string
}

export async function generateVerificationLink(email: string, type: string) {
  try {
    const response = await axios.post<{
      url: string
      sessionId: string
    }>(
      signupEndpoints.VERIFICATION_LINK,
      {},
      {
        params: {
          email,
          type,
        },
      }
    )

    return { url: response.data.url, sessionId: response.data.sessionId }
  } catch (error: any) {
    return { errorMessage: error.response.data.message }
  }
}
